import { useEffect, useState } from 'react';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import { useAppContext } from '../../../Services/AppContext';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import { useIsLatam } from '../../Region/Services/region.service';
import HealthPlanLaboratoryExamBabyLatam from '../Components/HealthPlanLaboratoryExam/HealthPlanLaboratoryExamBabyLatam';
import HealthPlanLaboratoryExamDiabetesLatam from '../Components/HealthPlanLaboratoryExam/HealthPlanLaboratoryExamDiabetesLatam';
import { FormHookCountry, FormHookResult } from './FormHook.interface';

const HealthPlanLaboratoryExamForms: FormHookCountry = {
	latam: {
		diabetes: HealthPlanLaboratoryExamDiabetesLatam,
	},
	// TODO Add actual forms in case country is not latam
	default: {
		meddibaby: HealthPlanLaboratoryExamBabyLatam,
		diabetes: HealthPlanLaboratoryExamDiabetesLatam,
	},
};

const useHealthPlanLaboratoryExamForm = (): FormHookResult => {
	const { globalTemplate } = useAppContext();
	const { healthPlan } = useHealthPlanContext();
	const isLatam = useIsLatam(globalTemplate);

	const [form, setForm] = useState<ItemScheme[]>(
		HealthPlanLaboratoryExamForms.default[
			healthPlan.code ?? HealthPlanCode.DIABETES
		],
	);

	useEffect(() => {
		const formScheme =
			HealthPlanLaboratoryExamForms[isLatam ? 'latam' : 'default'][
				isLatam
					? HealthPlanCode.DIABETES
					: healthPlan.code ?? HealthPlanCode.DIABETES
			];
		setForm(formScheme);
	}, [healthPlan.code, isLatam]);

	return {
		formScheme: form,
	};
};

export default useHealthPlanLaboratoryExamForm;
